import localForageHelper from '@/helpers/localforage.helper'
import onEnvironmentChange from '@/observables/environment.observable'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import type Environment from '@interfaces/environment.interface'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import type { AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'

export default class SpidermanService extends MainService {
  url: string
  logService = new LogService()

  constructor(spidermanUrl?: string) {
    super()
    if (!spidermanUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.spiderman
      })
    } else {
      this.url = spidermanUrl
    }
    this.logService.init('Spiderman Service')
  }

  // TODO: Deprecated, Remove after firebase migration
  public async generateJWTByCode(
    code: string,
    redirectUri: string,
    network: 'auth0' | 'facebook' | 'google' | 'twitter' | 'tiktok' | 'instagram',
    squidIdToProcess?: string,
    backendOptions?: { password: string; email: string }
  ) {
    const headers = await this.getHeaders(network !== 'auth0')
    const fingerObject = await (await FingerprintJS.load()).get()
    const fingerprint = (await localForageHelper.getItem('fingerprint')) || `${fingerObject?.visitorId}.${new Date().getTime()}`
    localForageHelper.setItem('fingerprint', fingerprint)

    return this.http
      .post(
        `${this.url}/generate/jwt/${network}`,
        {
          fingerprint,
          code,
          redirectUri,
          squidIdToProcess,
          pwd: backendOptions ? backendOptions.password : null,
          email: backendOptions ? backendOptions.email : null,
        },
        {
          headers,
        }
      )
      .then((r: AxiosResponse) => r.data || {})
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on generate JWT',
          error,
        })
        return error.response
      })
  }

  // TODO: Deprecated, Remove after firebase migration
  public async generateJWTByCodeImpersonate(jwt: string) {
    const headers = await this.getHeaders(true, jwt)
    return this.http
      .post(
        `${this.url}/generate/jwt/auth0`,
        {},
        {
          headers,
        }
      )
      .then((r: AxiosResponse) => r.data || {})
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on generate impersonate JWT',
          error,
        })
        return error.response
      })
  }

  // TODO: Deprecated, Remove after firebase migration
  public async getLongToken(token) {
    const URL = `${this.url}/generate/jwt/auth0`
    const headers = await this.getHeaders(true, token)
    headers['Content-Type'] = 'application/json'

    return this.http
      .post(URL, {}, { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error retrieving long token',
          error,
        })
        return error.response
      })
  }

  // TODO: Deprecated, Remove after firebase migration
  public async checkEmailAndPassword(email: string, pwd: string, returnUser = false): Promise<AxiosResponse> {
    return await this.http.post(`${this.url}/verify/auth0?returnUser=${returnUser}`, {
      email,
      pwd,
    })
  }

  // TODO: Deprecated, Remove after payments migration
  public async selfImpersonate(whitelabel = '-', url = window.location.origin): Promise<{ url: string }> {
    const headers = await this.getHeaders()
    return await this.http
      .post(`${this.url}/impersonate/self`, { type: 'email', url, whitelabel, organization: '56605cfad4c606c85eb10dd6' }, { headers })
      .then((r: AxiosResponse) => r.data || {})
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on self impersonate JWT',
          error,
        })
        return false
      })
  }

  // TODO: Deprecated, Remove after firebase migration
  public async resetPassword(token: string, pwd: string): Promise<void> {
    const headers = await this.getHeaders(true, token)
    return await this.http
      .patch(`${this.url}/hub/reset-password/auth0`, { pwd }, { headers })
      .then((r: AxiosResponse) => r.data || {})
      .catch((error: any) => {
        this.logService.error({
          message: 'Could not change password',
          error,
        })
        return error.response
      })
  }
}
